'use strict';

/**
 *
 * @name: MODULE angulartics.google.tagmanagerNowness CONFIG
 *
 */

/**
 * @license Angulartics v0.16.3
 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
 * Google Tag Manager Plugin Contributed by http://github.com/danrowe49
 * License: MIT
 */

/**
 * @ngdoc overview
 * @name angulartics.google.analytics
 * Enables analytics support for Google Tag Manager (http://google.com/tagmanager)
 */

function AngularticsConfig($analyticsProvider) {

  'ngInject';

  /**
   * Send content views to the dataLayer
   *
   * @param {string} path Required 'content name' (string) describes the content loaded
   */

  $analyticsProvider.registerPageTrack(function(path, inputData) {
    if (inputData) {
      var dataLayer = window.dataLayer = window.dataLayer || [];
      var data = {
        attributes: {
          videoID: 'not applicable',
          videoName: 'not applicable'
        },
        page: {
          attributes: {
            articleName: 'not applicable',
            articlePublisher: 'not applicable',
            articleAuthor: 'not applicable'
          },
          pageInfo: {
            pageName: path,
            //            pageID: inputData.page.pageID || '#',
            pageTitle: inputData.page.pageTitle,
            sysEnv: inputData.page.sysEnv || 'desktop',
            language: inputData.page.language,
            country: inputData.page.country,
            geoRegion: inputData.page.geoRegion
          },
          category: {
            primaryCategory: inputData.category.primaryCategory,
            subCategory1: inputData.category.subCategory1,
            subCategory2: inputData.category.subCategory2,
            pageType: inputData.category.pageType
          },
        },
        version: '1.0',
        event: 'content-view'
      };

      if (inputData.attributes) {
        data.attributes = inputData.attributes;
      }

      if (inputData.page.attributes) {
        data.page.attributes = inputData.page.attributes;
      }

      if (inputData.page.onsiteSearchResult || inputData.page.onsiteSearchResult === 0) {
        data.page.pageInfo.onsiteSearchResult = inputData.page.onsiteSearchResult;
      }

      if (inputData.page.onsiteSearchTerm || inputData.page.onsiteSearchTerm === 0) {
        data.page.pageInfo.onsiteSearchTerm = inputData.page.onsiteSearchTerm;
      }

      if (inputData.user) {
        data.user = {
          profile: {
            profileInfo: {
              profileID: inputData.user.id.toString(),
            },
            segment: inputData.user.segment
          }
        };
        if (inputData.user.email) {
          data.user.profile.profileInfo.email = sha1(inputData.user.email);
        } else {
          data.user.profile.profileInfo.email = sha1('socialNetworkAccount');
        }
      } else {
        data.user = {
          profile: {
            segment: 'Guests'
          }
        };
      }
      void 0;
      dataLayer.push(data);
    }
  });

  /**
   * Send interactions to the dataLayer, i.e. for event tracking in Google Analytics
   * @name eventTrack
   *
   * @param {string} action Required 'action' (string) associated with the event
   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
   */

  $analyticsProvider.registerEventTrack(function(action, properties) {
    void 0;
    var dataLayer = window.dataLayer = window.dataLayer || [];
    var data = {
      event: 'onclick',
      eventInfo: {
        eventName: action,
        eventAction: properties.eventAction,
        eventPoints: properties.eventPoints,
        type: 'event'
      }
    };
    if (properties.attributes) {
      data.eventInfo.attributes = properties.attributes;
    }
    //      if (properties.eventAttributes) {
    //        data.eventInfo.attributes = properties.eventAttributes;
    //      }
    void 0;
    dataLayer.push(data);
  });
}

export default AngularticsConfig;



// WEBPACK FOOTER //
// ./app/components/nn-analytics/angulartics-gtm-nowness.config.js